/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface FindAllPalAuthPlatforms200Response
 */
export interface FindAllPalAuthPlatforms200Response {
    /**
     * 
     * @type {Array<PalAuthPlatform>}
     * @memberof FindAllPalAuthPlatforms200Response
     */
    data?: Array<PalAuthPlatform>;
}

/**
 * Check if a given object implements the FindAllPalAuthPlatforms200Response interface.
 */
export function instanceOfFindAllPalAuthPlatforms200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalAuthPlatforms200ResponseFromJSON(json: any): FindAllPalAuthPlatforms200Response {
    return FindAllPalAuthPlatforms200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthPlatforms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthPlatforms200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PalAuthPlatformFromJSON)),
    };
}

export function FindAllPalAuthPlatforms200ResponseToJSON(value?: FindAllPalAuthPlatforms200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PalAuthPlatformToJSON)),
    };
}

